import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SparklesIcon } from '@heroicons/react/24/outline';
import OnboardingWizard from '../components/onboarding/OnboardingWizard';
import { stepFromStatus } from '../components/onboarding/onboardingSteps';
import { DEFAULT_HOME_ROUTE } from '../config/navAccessMap';
import { fetchOnboardingStatus } from '../services/onboardingApi';

export default function OnboardingPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState(1);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchOnboardingStatus()
      .then((data) => {
        if (cancelled) return;
        setStatus(data);
        if (data.requires_onboarding === false) {
          navigate(DEFAULT_HOME_ROUTE, { replace: true });
          return;
        }
        setStep(stepFromStatus(data));
      })
      .catch(() => {
        if (!cancelled) setStatus({ current_step: 'organization' });
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (status?.onboarding_completed) {
    navigate(DEFAULT_HOME_ROUTE, { replace: true });
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-blue-100 text-blue-600 mb-4">
            <SparklesIcon className="w-8 h-8" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900">Welcome to Agentic RCM</h1>
          <p className="mt-2 text-gray-600">Set up your organization, upload revenue data, and load your first guided demo.</p>
        </div>

        <OnboardingWizard
          mode="signup"
          status={status}
          setStatus={setStatus}
          step={step}
          setStep={setStep}
          showStepper
          onCompleteSuccess={() => navigate(DEFAULT_HOME_ROUTE, { replace: true })}
        />
      </div>
    </div>
  );
}
